import * as actionTypes from "./actionTypes";

export const getDashboardCardDataAction = () => ({
    type: actionTypes.GET_DASHBOARD_CARD_DATA,
});

export const setWebsiteLoadingAction = (payload) => ({
    type: actionTypes.SET_WEBSITE_LOADING,
    payload
})